import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecentRequisitionsComponent } from './recent-requisitions/recent-requisitions.component';
import { RequisitionActivityComponent } from './requisition-activity/requisition-activity.component';
import { EntityActivitiesModule } from 'src/app/shared/entity-activities/entity-activities.module';
import { RequisitionCardModule } from 'src/app/pages/mission-control-page/requisitions-page/requisition-card/requisition-card.module';

@NgModule({
  declarations: [RecentRequisitionsComponent, RequisitionActivityComponent],
  imports: [
    CommonModule,
    EntityActivitiesModule,
    RequisitionCardModule
  ],
  exports: [RecentRequisitionsComponent, RequisitionActivityComponent],
  entryComponents: [RequisitionActivityComponent]
})
export class RequisitionsModule { }
